define('home/mixins/asGenericCard',[
    'underscore',

    'home/utils/layoutUtils',
    'home/mixins/withThreadCardDefaultFooter',
    'home/mixins/withTruncate',
], function (
    _,

    layoutUtils,
    withThreadCardDefaultFooter,
    withTruncate
) {
    'use strict';

    var asGenericCard = {
        className: function (existingClassName) {
            if (_.isFunction(existingClassName))
                existingClassName = existingClassName.apply(this, _.rest(arguments));

            existingClassName = existingClassName || '';

            return [
                'card',
                'card-generic',
                'card-generic-' + this.model.get('verb'),
                existingClassName,
            ].join(' ');
        },

        initialize: function (_initialize, options) {
            options = options || {};
            _initialize.call(this, options);

            this.channel = options.channel;
            this.hideImage = options.hideImage;
            this.listenTo(this.model.thread, 'change:content', this.render);
            this.numTitleLines = options.numTitleLines || 3;
        },

        serializeData: function (_serializeData) {
            var data = _serializeData.call(this);
            var thread = this.model.thread;

            return _.defaults(data, {
                discussionRoute: thread.getDiscussionRoute(this.channel),
                threadDescriptionHTML: thread.getDefaultDescription(),
                image: !this.hideImage && !layoutUtils.isNarrowLayout() && thread.getImage(),
                numTitleLines: this.numTitleLines,
            });
        },
    };

    return function () {
        withThreadCardDefaultFooter.apply(this, arguments);
        withTruncate.apply(this, arguments);

        this.className = _.wrap(this.className, asGenericCard.className);
        this.initialize = _.wrap(this.initialize, asGenericCard.initialize);
        this.serializeData = _.wrap(this.serializeData, asGenericCard.serializeData);
    };
});

